define('plugin/invoice/collection/InvoicePaymentMethodCollection',['require','lib/collection/FilterableCollection','lib/collection/BaseCollection','plugin/invoice/model/InvoicePaymentMethodModel'],function (require) {

    var FilterableCollection = require('lib/collection/FilterableCollection');
    var BaseCollection = require('lib/collection/BaseCollection');
    var InvoicePaymentMethodModel = require('plugin/invoice/model/InvoicePaymentMethodModel');

    /**
     * Invoice package instance collection
     *
     * @class InvoicePackageInstanceCollection
     */
    return FilterableCollection.extend({

        url: '/ext/payment/payment-methods/',
        model: InvoicePaymentMethodModel

    });

});
